<template>
    <v-flex xl12>
        <h2>Contatos <span class="text-title-header"> | Ligamos para você</span></h2>
        <v-divider></v-divider>
        <br/>
        <router-view></router-view>
    </v-flex>
</template>
<script>
export default {
  name: 'contacts',
  mounted: function () {
    this.$nextTick(function () {

    })
  }
}
</script>
